var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { Platforms } from 'fk-cp-common-components/commonFacade/InitiateFacadeUtils';
import ApiCallerInterface from '../utils/ApiCallerInterface';
import { FormattedMessage, formatMessage } from '../utils/i18n';
import Image from '../components/common/ProgressiveImage';
import { format as dateFormat } from 'fk-cp-shared/utils/DateUtils';
import store from '../clientStore';
import SnackbarContext from '@common/Snackbar/SnackbarContext';
var props = {
    store: store,
    apiCaller: ApiCallerInterface,
    stringTemplate: FormattedMessage,
    imageTemplate: Image,
    formatMessage: formatMessage,
    dateFormat: dateFormat,
    platform: Platforms.APP
};
var emptyFn = function () { return null; };
var mapFacadeToPropsWrapper = function (mapFacadeToProps, props) {
    var facadeAsProps = {};
    Object.keys(mapFacadeToProps).forEach(function (facade) {
        facadeAsProps[facade] = new mapFacadeToProps[facade](props);
    });
    return facadeAsProps;
};
export function withFacade(mapFacadeToProps, jestStore) {
    if (jestStore) {
        props = Object.assign({}, props, {
            store: jestStore
        });
    }
    return function (WrappedComponent) {
        return function (propsComp) {
            var _a = useContext(SnackbarContext) || {}, _b = _a.showSnackbar, showSnackbar = _b === void 0 ? emptyFn : _b, _c = _a.hideSnackbar, hideSnackbar = _c === void 0 ? emptyFn : _c;
            return <WrappedComponent {...propsComp} {...mapFacadeToPropsWrapper(mapFacadeToProps, __assign(__assign({}, props), { showSnackbar: showSnackbar, hideSnackbar: hideSnackbar }))}/>;
        };
    };
}
